import React from "react";

function CreateGameModal({
 isOpen,
 selectedMatchup,
 gameForm,
 setGameForm,
 onCreate,
 onCancel,

 savedLocations = [],
 locationSuggestions = [],
 setLocationSuggestions = () => { },

 showCreateLocationModal,
 setShowCreateLocationModal,
 showEditLocationsModal,
 setShowEditLocationsModal,

 newSavedLocationForm,
 setNewSavedLocationForm,
 editingSavedLocations = [],

 handleCreateSavedLocation,
 handleEditSavedLocationField,
 handleSaveEditedLocations,
 handleDeleteSavedLocation,
 handleSelectSavedLocation,
}) {
 if (!isOpen || !selectedMatchup) return null;

 const handleLocationChange = (e) => {
  const value = e.target.value;

  setGameForm({ ...gameForm, location: value });

  const search = value.trim().toLowerCase();

  if (!search) {
   setLocationSuggestions([]);
   return;
  }

  const matches = savedLocations.filter((loc) =>
   (loc.name || "").toLowerCase().startsWith(search)
  );

  setLocationSuggestions(matches);
 };

 return (
  <>
   <div className="division-modal-overlay">
    <div className="division-modal-content">
     <h3>Create Game</h3>
     <p>
      {selectedMatchup.teamA?.name || "TBD"} vs {selectedMatchup.teamB?.name || "TBD"}
     </p>

     <label>Date:</label>
     <input
      type="date"
      value={gameForm.date}
      onChange={(e) => setGameForm({ ...gameForm, date: e.target.value })}
     />

     <label>Time:</label>
     <input
      type="time"
      value={gameForm.time}
      onChange={(e) => setGameForm({ ...gameForm, time: e.target.value })}
     />

     <div className="create-game-saved-location-group">
      <label className="create-game-saved-location-label">Location</label>

      <div className="create-game-saved-location-input-wrap">
       <input
        type="text"
        placeholder="Gym Name"
        value={gameForm.location || ""}
        onChange={handleLocationChange}
        autoComplete="off"
       />

       {locationSuggestions.length > 0 && (
        <div className="create-game-saved-location-dropdown">
         {locationSuggestions.map((loc) => (
          <div
           key={loc.id}
           className="create-game-saved-location-dropdown-item"
           onClick={() => handleSelectSavedLocation(loc)}
          >
           {loc.name}
          </div>
         ))}
        </div>
       )}
      </div>
     </div>

     <div className="create-game-saved-location-links">
      <button
       type="button"
       className="create-game-saved-location-link-btn"
       onClick={() => {
        setShowCreateLocationModal(true);
        setNewSavedLocationForm({
         name: gameForm.location || "",
         location_url: gameForm.location_url || "",
        });
       }}
      >
       + Create a new location
      </button>

      <button
       type="button"
       className="create-game-saved-location-link-btn"
       onClick={() => setShowEditLocationsModal(true)}
      >
       Edit current locations
      </button>
     </div>

     <label>Location URL:</label>
     <input
      type="text"
      placeholder="https://maps.google.com/..."
      value={gameForm.location_url || ""}
      onChange={(e) => setGameForm({ ...gameForm, location_url: e.target.value })}
     />

     <div className="division-modal-buttons">
      <button
       onClick={() =>
        onCreate({
         ...gameForm,
         match_id: selectedMatchup.matchId,
        })
       }
      >
       Create Game
      </button>

      <button onClick={onCancel}>Cancel</button>
     </div>
    </div>
   </div>

   {showCreateLocationModal && (
    <div className="division-modal-overlay">
     <div className="division-modal-content saved-location-small-modal">
      <h3>Create New Location</h3>

      <label>Location Name</label>
      <input
       type="text"
       value={newSavedLocationForm.name}
       onChange={(e) =>
        setNewSavedLocationForm((prev) => ({
         ...prev,
         name: e.target.value,
        }))
       }
      />

      <label>Location URL</label>
      <input
       type="text"
       value={newSavedLocationForm.location_url}
       onChange={(e) =>
        setNewSavedLocationForm((prev) => ({
         ...prev,
         location_url: e.target.value,
        }))
       }
      />

      <div className="division-modal-buttons">
       <button type="button" onClick={handleCreateSavedLocation}>
        Create
       </button>
       <button type="button" onClick={() => setShowCreateLocationModal(false)}>
        Cancel
       </button>
      </div>
     </div>
    </div>
   )}

   {showEditLocationsModal && (
    <div className="division-modal-overlay">
     <div className="division-modal-content saved-location-edit-modal">
      <h3>Edit Current Locations</h3>

      <div className="saved-location-edit-list">
       {editingSavedLocations.length === 0 ? (
        <p>No saved locations yet.</p>
       ) : (
        editingSavedLocations.map((loc) => (
         <div key={loc.id} className="saved-location-edit-item">
          <input
           type="text"
           value={loc.name || ""}
           placeholder="Location name"
           onChange={(e) =>
            handleEditSavedLocationField(loc.id, "name", e.target.value)
           }
          />

          <div className="saved-location-url-row">
           <input
            type="text"
            value={loc.location_url || ""}
            placeholder="Location URL"
            onChange={(e) =>
             handleEditSavedLocationField(loc.id, "location_url", e.target.value)
            }
           />

           <button
            type="button"
            className="saved-location-delete-btn"
            onClick={() => handleDeleteSavedLocation(loc.id)}
            title="Delete saved location"
           >
            🗑️
           </button>
          </div>
         </div>
        ))
       )}
      </div>

      <div className="division-modal-buttons">
       <button type="button" onClick={handleSaveEditedLocations}>
        Save
       </button>
       <button type="button" onClick={() => setShowEditLocationsModal(false)}>
        Cancel
       </button>
      </div>
     </div>
    </div>
   )}
  </>
 );
}

export default CreateGameModal;